const DAY = 24 * 60 * 60 * 1000;

const dateFormat = new Intl.DateTimeFormat("nl-NL", {
  day: "numeric",
  month: "short",
  year: "numeric",
});
const relativeFormat = new Intl.RelativeTimeFormat("nl-NL", { numeric: "auto" });

// "2 mrt 2026"
export const formatDate = (value: string | Date) => dateFormat.format(new Date(value));

// "over 3 dagen", "morgen", "vandaag", "2 dagen geleden": rounded to whole days.
export const formatRelativeDays = (value: string | Date, now: Date = new Date()) => {
  const days = (new Date(value).getTime() - now.getTime()) / DAY;
  // `|| 0` turns -0 into 0, which formats as "vandaag".
  return relativeFormat.format(Math.round(days) || 0, "day");
};
